export default "__VITE_ASSET__CNXW0FT6__"